export enum FileType {
  PNG = 'png',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PDF = 'PDF',
  MP3 = 'mp3'
}
